import React from 'react';
import { HighScore } from '../firebase';

interface Props {
  highScores: HighScore[];
  isLoading?: boolean;
}

/**
 * Displays a shared high-score leaderboard.
 */
const HighScoreList: React.FC<Props> = ({ highScores, isLoading = false }) => {
  // Show loading spinner or empty slots if high scores are loading
  if (isLoading) {
    return (
      <div className="high-score-list loading">
        <h3>High Scores</h3>
        <div className="loading-spinner"></div>
      </div>
    );
  }

  // Show no scores message if there are no high scores
  if (highScores.length === 0) {
    return (
      <div className="high-score-list empty">
        <h3>High Scores</h3>
        <p className="no-scores">No scores yet. Be the first!</p>
      </div>
    );
  }

  return (
    <div className="high-score-list">
      <h3>High Scores</h3>
      <ol>
        {highScores.map((hs, idx) => (
          <li key={idx} className={idx < 3 ? `rank-${idx + 1}` : ''}>
            <span className="rank">{idx + 1}.</span>
            <span className="name">{hs.name}</span>
            <span className="score">{hs.score}</span>
          </li>
        ))}
      </ol>
    </div>
  );
};

export default HighScoreList;